export var ShaderName = /* @__PURE__ */ ((ShaderName2) => {
  ShaderName2["VERTEX"] = "vertex";
  ShaderName2["FRAGMENT"] = "fragment";
  ShaderName2["LEAVES_FROM_NODES_SHADER"] = "leaves_from_nodes_shader";
  return ShaderName2;
})(ShaderName || {});
